import React from "react";
import { slimImage } from "@/service/utils";
import { StarIcon } from "@/icons";
import NoDishPicture from "@/images/no_dish_picture.svg";
import "./index.less";

export function formatDistance(distance) {
  if (distance === null || distance === undefined || distance === "") return "";
  const meters = Number(distance);
  if (Number.isNaN(meters)) return String(distance);
  if (meters >= 1000) return `${(meters / 1000).toFixed(1)} km`;
  return `${Math.round(meters)} m`;
}

/**
 * 纯渲染组件，用于 ReactDOMServer.renderToString
 * @param {Object} props
 * @param {Object} props.restaurant - 餐厅数据
 * @param {string} props.avgPriceLabel - 平均价格标签文本 (如 "avg")
 * @param {Function} [props.onClick] - 点击回调 (可选，renderToString 时不需要)
 */
export const MapViewCard = ({ restaurant, avgPriceLabel }) => {
  const data = restaurant || {};
  const {
    cover,
    name,
    ratings_avg,
    format_avg_price,
    cuisines = [],
    distance,
  } = data;

  const title = name || "";
  const rating = ratings_avg ? Number(ratings_avg).toFixed(1) : "0.0";
  const price = `${format_avg_price}${avgPriceLabel}`;
  const cuisineNames = cuisines
    .map((c) => (typeof c === "string" ? c : c?.name))
    .filter(Boolean)
    .slice(0, 2);
  const distanceLabel = formatDistance(distance);
  const imageSrc = cover || NoDishPicture;

  const handleClick = () => {
    window.open(restaurant.website_detail_url, "_blank");
  };

  return (
    <a
      className="ui-map-view-card"
      data-id={restaurant.id}
      id={`map-restaurant-card-${restaurant.id}`}
      href={restaurant.website_detail_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="ui-map-view-card__media">
        <img
          src={imageSrc}
          alt={title}
          onError={(e) => {
            e.currentTarget.src = NoDishPicture;
          }}
        />
      </div>
      <div className="ui-map-view-card__body">
        <div className="ui-map-view-card__title">{title}</div>
        <div className="ui-map-view-card__address">
          <div className="ui-map-view-card__rate">
            <StarIcon></StarIcon>
            <span>{rating}</span>
          </div>
          <div className="ui-map-view-card__avg">{price}</div>
          <div className="ui-map-view-card__cuisine">
            <span>{cuisineNames.join(" · ")}</span>
          </div>
          <div className="ui-map-view-card__distance">{distanceLabel}</div>
        </div>
      </div>
    </a>
  );
};
